// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.cancalOrSubmitBtn {
    margin: 10px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    border-radius: 20px;
    padding: 5px 20px 5px 20px;
    font-size: 10pt;
    text-align: center;
    font-weight: 500;
    color: #ffffff;
    border: none;
    font-weight: 600;
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif ;
}
`, "",{"version":3,"sources":["webpack://./src/components/QueuesManagment/modals/modal.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,kFAAkF;IAClF,0BAA0B;IAC1B,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,4DAA4D;AAChE","sourcesContent":["\r\n.cancalOrSubmitBtn {\r\n    margin: 10px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    border-radius: 20px;\r\n    padding: 5px 20px 5px 20px;\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    font-weight: 500;\r\n    color: #ffffff;\r\n    border: none;\r\n    font-weight: 600;\r\n    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif ;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
